const INTPUB_DECISION_STATES = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
};

export default INTPUB_DECISION_STATES;
